export interface BlStyle {
  name: string;
  tagline: string;
  desc: string;
  traits: string[];
  sample: string;
  cover: string;
}

export interface BlComic {
  id: string;
  title: string;
  author: string;
  year: string;
  style: string;
  type: string;
  rating: number;
  chapters: number;
  status: "连载" | "完结";
  tags: string[];
  desc: string;
  cover: string;
}

export const heroBg =
  "https://readdy.ai/api/search-image?query=ethereal%20romantic%20abstract%20illustration%2C%20flowing%20watercolor%20silk%20ribbons%20in%20rose%20pink%2C%20coral%20and%20cream%20gold%2C%20soft%20glowing%20light%2C%20delicate%20ink%20blooms%2C%20warm%20dreamy%20atmosphere%2C%20editorial%20art%20background%2C%20elegant%20minimal%20composition%2C%20no%20text&width=1600&height=900&seq=hero-bg-blmanga&orientation=landscape";

export const aboutImg =
  "https://readdy.ai/api/search-image?query=artist%20workspace%20with%20sketchbook%2C%20watercolor%20paints%20and%20rose%20brushes%20on%20warm%20wooden%20desk%2C%20soft%20natural%20light%2C%20cozy%20creative%20studio%20mood%2C%20warm%20cream%20and%20coral%20tones%2C%20no%20text&width=1200&height=800&seq=about-blmanga&orientation=landscape";

export const styles: BlStyle[] = [
  {
    name: "水彩晕染",
    tagline: "如诗般的温柔流动",
    desc: "以流动水彩与晕染叠色勾勒光影，边缘柔和、意境通透，特别适合节奏舒缓、情绪细腻的感情线，画面自带呼吸感。",
    traits: ["柔和叠色", "通透意境", "情绪细腻"],
    sample: "《暮色来信》《月光序章》",
    cover:
      "https://readdy.ai/api/search-image?query=delicate%20watercolor%20illustration%2C%20two%20silhouettes%20by%20a%20twilight%20window%2C%20flowing%20rose%20and%20peach%20watercolor%20washes%2C%20gentle%20pigment%20blooms%2C%20soft%20paper%20texture%2C%20warm%20romantic%20quiet%20mood%2C%20manga%20cover%20art%2C%20no%20text&width=600&height=900&seq=cover-watercolor-1&orientation=portrait",
  },
  {
    name: "水墨国风",
    tagline: "留白处的东方气韵",
    desc: "借鉴水墨丹青的用笔与留白，线条收放自如、设色淡雅，把侠义、江湖与克制隐忍的情感揉进古风叙事，意境悠远。",
    traits: ["笔墨留白", "古风意境", "克制深情"],
    sample: "《青灯照影》《纸鸢寄情》",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20chinese%20ink%20painting%2C%20bamboo%20and%20paper%20lantern%20at%20night%2C%20wash%20style%20sumi-e%2C%20warm%20beige%20and%20deep%20brown%20tones%20with%20faint%20gold%2C%20poetic%20minimal%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-ink-1&orientation=portrait",
  },
  {
    name: "清新淡彩",
    tagline: "夏日般轻盈明亮",
    desc: "高亮低饱和的淡彩上色，线条干净、氛围清爽，常见于校园与日常题材，把青春期的悸动画得明亮而治愈。",
    traits: ["干净线条", "明亮治愈", "青春气息"],
    sample: "《微光拾夏》《浅岸》",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20fresh%20anime%20illustration%2C%20sunny%20school%20rooftop%20in%20summer%2C%20two%20figures%2C%20light%20pastel%20cream%20and%20peach%20tones%2C%20clean%20soft%20lighting%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-fresh-1&orientation=portrait",
  },
  {
    name: "厚涂光影",
    tagline: "光影交汇的立体叙事",
    desc: "用厚重的笔触与强烈的光影对比塑造氛围，人物与场景质感强烈，擅长刻画悬疑、都市等情绪张力十足的故事。",
    traits: ["立体质感", "光影强烈", "张力十足"],
    sample: "《潮汐之间》《雾中灯塔》",
    cover:
      "https://readdy.ai/api/search-image?query=digital%20painting%20thick%20impasto%2C%20ocean%20shoreline%20at%20sunset%2C%20two%20figures%2C%20rich%20warm%20coral%20and%20gold%2C%20soft%20glow%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-thick-1&orientation=portrait",
  },
  {
    name: "复古手绘",
    tagline: "旧时光里的浪漫余温",
    desc: "带有胶片颗粒与怀旧纸张质感的复古画风，设色温暖、笔触考究，将年代故事与缠绵情感沉淀出厚重的质感。",
    traits: ["怀旧质感", "年代氛围", "笔触考究"],
    sample: "《旧梦缱绻》《玫瑰与夜莺》",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20retro%20comic%20illustration%2C%201930s%20shanghai%20style%2C%20sepia%20warm%20tones%2C%20elegant%20figures%2C%20nostalgic%20warm%20paper%20texture%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-retro-1&orientation=portrait",
  },
  {
    name: "赛璐璐上色",
    tagline: "鲜明利落的清爽动画感",
    desc: "线条利落、色块干净的赛璐璐上色，色彩明快饱和，常见于奇幻与科幻题材，画面充满青春能量与想象力。",
    traits: ["利落线条", "明快饱和", "动感十足"],
    sample: "《琉璃之约》《星轨交叠》",
    cover:
      "https://readdy.ai/api/search-image?query=glossy%20clean%20anime%20cel%20style%2C%20fantasy%20palace%20with%20warm%20golden%20light%2C%20two%20figures%2C%20vibrant%20warm%20saturated%20colors%2C%20crisp%20linework%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-cell-1&orientation=portrait",
  },
  {
    name: "铅笔线稿",
    tagline: "返璞归真的素净笔触",
    desc: "保留铅笔的笔触与纸张肌理，线条松弛有度、留白丰富，擅长细腻的心理刻画，给人安静又治愈的阅读体验。",
    traits: ["素净笔触", "肌理感强", "细腻心理"],
    sample: "《拾光备忘录》《琴弦未眠》",
    cover:
      "https://readdy.ai/api/search-image?query=delicate%20pencil%20line%20art%20sketch%2C%20cozy%20room%20with%20books%20and%20plants%2C%20two%20figures%2C%20graphite%20linework%20on%20warm%20paper%2C%20soft%20shading%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-pencil-1&orientation=portrait",
  },
  {
    name: "电影感分镜",
    tagline: "镜头语言推动情绪",
    desc: "大量运用特写、空镜与蒙太奇分镜，用镜头语言与光影调度推进叙事，画面叙事感强，适合都市情感与悬疑题材。",
    traits: ["镜头调度", "叙事感强", "氛围营造"],
    sample: "《夜航灯》《雾中灯塔》",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20manga%20panel%20style%2C%20night%20city%20street%20with%20warm%20lantern%20light%2C%20dramatic%20light%20and%20shadow%2C%20two%20figures%2C%20warm%20amber%20and%20cream%2C%20film%20still%20mood%2C%20no%20text&width=600&height=900&seq=cover-cine-1&orientation=portrait",
  },
];

export const comics: BlComic[] = [
  {
    id: "c1",
    title: "暮色来信",
    author: "苏晚",
    year: "2024",
    style: "水彩晕染",
    type: "现代",
    rating: 9.4,
    chapters: 36,
    status: "连载",
    tags: ["久别重逢", "书信", "慢热"],
    desc: "一封迟到的信，让两个在都市里各自生活的人重新走向彼此，水彩般温柔的情感层层晕开。",
    cover:
      "https://readdy.ai/api/search-image?query=delicate%20watercolor%20illustration%2C%20two%20silhouettes%20by%20a%20twilight%20window%2C%20flowing%20rose%20and%20peach%20watercolor%20washes%2C%20gentle%20pigment%20blooms%2C%20soft%20paper%20texture%2C%20warm%20romantic%20quiet%20mood%2C%20manga%20cover%20art%2C%20no%20text&width=600&height=900&seq=cover-watercolor-1&orientation=portrait",
  },
  {
    id: "c2",
    title: "青灯照影",
    author: "叶舟",
    year: "2023",
    style: "水墨国风",
    type: "古风",
    rating: 9.1,
    chapters: 52,
    status: "完结",
    tags: ["江湖", "师徒", "隐忍"],
    desc: "庙堂与江湖之间，少年与师父隔着十数年光阴相望，水墨留白间藏着最克制的深情。",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20chinese%20ink%20painting%2C%20bamboo%20and%20paper%20lantern%20at%20night%2C%20wash%20style%20sumi-e%2C%20warm%20beige%20and%20deep%20brown%20tones%20with%20faint%20gold%2C%20poetic%20minimal%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-ink-1&orientation=portrait",
  },
  {
    id: "c3",
    title: "微光拾夏",
    author: "林汐",
    year: "2024",
    style: "清新淡彩",
    type: "校园",
    rating: 8.8,
    chapters: 28,
    status: "连载",
    tags: ["校园", "双向暗恋", "青春"],
    desc: "盛夏天台与放学后的便利店，两个少年在明亮清爽的画面里笨拙地靠近彼此。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20fresh%20anime%20illustration%2C%20sunny%20school%20rooftop%20in%20summer%2C%20two%20figures%2C%20light%20pastel%20cream%20and%20peach%20tones%2C%20clean%20soft%20lighting%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-fresh-1&orientation=portrait",
  },
  {
    id: "c4",
    title: "夜航灯",
    author: "陈默",
    year: "2023",
    style: "电影感分镜",
    type: "都市",
    rating: 9.2,
    chapters: 44,
    status: "完结",
    tags: ["都市", "救赎", "成长"],
    desc: "深夜电台与末班地铁之间，镜头缓慢推近，两个孤独的人靠着一盏灯互相取暖。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20manga%20panel%20style%2C%20night%20city%20street%20with%20warm%20lantern%20light%2C%20dramatic%20light%20and%20shadow%2C%20two%20figures%2C%20warm%20amber%20and%20cream%2C%20film%20still%20mood%2C%20no%20text&width=600&height=900&seq=cover-cine-1&orientation=portrait",
  },
  {
    id: "c5",
    title: "旧梦缱绻",
    author: "顾言",
    year: "2022",
    style: "复古手绘",
    type: "民国",
    rating: 8.9,
    chapters: 40,
    status: "完结",
    tags: ["民国", "世家", "破镜重圆"],
    desc: "沪上旧事与留声机里的低语，泛黄的笔触里，两个世家子弟在时代洪流中重逢。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20retro%20comic%20illustration%2C%201930s%20shanghai%20style%2C%20sepia%20warm%20tones%2C%20elegant%20figures%2C%20nostalgic%20warm%20paper%20texture%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-retro-1&orientation=portrait",
  },
  {
    id: "c6",
    title: "琉璃之约",
    author: "白鹭",
    year: "2024",
    style: "赛璐璐上色",
    type: "奇幻",
    rating: 8.6,
    chapters: 31,
    status: "连载",
    tags: ["奇幻", "契约", "甜宠"],
    desc: "光怪陆离的幻想世界里，少年与守护者立下琉璃之约，明快色彩下藏着温暖冒险。",
    cover:
      "https://readdy.ai/api/search-image?query=glossy%20clean%20anime%20cel%20style%2C%20fantasy%20palace%20with%20warm%20golden%20light%2C%20two%20figures%2C%20vibrant%20warm%20saturated%20colors%2C%20crisp%20linework%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-cell-1&orientation=portrait",
  },
  {
    id: "c7",
    title: "潮汐之间",
    author: "江阑",
    year: "2023",
    style: "厚涂光影",
    type: "都市",
    rating: 9.0,
    chapters: 48,
    status: "完结",
    tags: ["都市", "海员", "深情"],
    desc: "潮起潮落的海岸线上，归来与等待交织，厚涂光影把这份沉默的深情烘托到极致。",
    cover:
      "https://readdy.ai/api/search-image?query=digital%20painting%20thick%20impasto%2C%20ocean%20shoreline%20at%20sunset%2C%20two%20figures%2C%20rich%20warm%20coral%20and%20gold%2C%20soft%20glow%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-thick-1&orientation=portrait",
  },
  {
    id: "c8",
    title: "纸鸢寄情",
    author: "沈砚",
    year: "2023",
    style: "水墨国风",
    type: "古风",
    rating: 9.3,
    chapters: 50,
    status: "完结",
    tags: ["古风", "青梅竹马", "家国"],
    desc: "一只断线的纸鸢飞越半生，故人重逢时，水墨长卷里尽是不曾说出口的牵挂。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%2C%20kite%20flying%20over%20old%20courtyard%2C%20flowing%20wash%20lines%2C%20warm%20beige%20and%20terracotta%2C%20poetic%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-ink-2&orientation=portrait",
  },
  {
    id: "c9",
    title: "浅岸",
    author: "夏禾",
    year: "2024",
    style: "清新淡彩",
    type: "校园",
    rating: 8.5,
    chapters: 26,
    status: "连载",
    tags: ["校园", "治愈", "日常"],
    desc: "春日河岸的浅滩边，两个少年共享同一片阳光，淡彩笔触记录下最轻盈的日常。",
    cover:
      "https://readdy.ai/api/search-image?query=light%20anime%20illustration%2C%20gentle%20riverbank%20in%20spring%2C%20two%20figures%2C%20soft%20cream%20and%20peach%20pastel%2C%20airy%20and%20clean%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-fresh-2&orientation=portrait",
  },
  {
    id: "c10",
    title: "雾中灯塔",
    author: "周澄",
    year: "2022",
    style: "厚涂光影",
    type: "悬疑",
    rating: 8.7,
    chapters: 38,
    status: "完结",
    tags: ["悬疑", "海岛", "救赎"],
    desc: "迷雾海岛上的灯塔长明，秘密层层剥开，厚重笔触下的真相与救赎同样灼人。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20digital%20painting%2C%20lighthouse%20in%20mist%2C%20warm%20beam%20of%20light%2C%20two%20figures%2C%20atmospheric%20thick%20brush%2C%20warm%20amber%20tones%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-thick-2&orientation=portrait",
  },
  {
    id: "c11",
    title: "拾光备忘录",
    author: "许棠",
    year: "2024",
    style: "铅笔线稿",
    type: "日常",
    rating: 8.4,
    chapters: 22,
    status: "连载",
    tags: ["日常", "同居", "细水长流"],
    desc: "用铅笔慢慢记下生活的边角，两个人把平凡日子过成了温柔的诗，素净又有余味。",
    cover:
      "https://readdy.ai/api/search-image?query=delicate%20pencil%20line%20art%20sketch%2C%20cozy%20room%20with%20books%20and%20plants%2C%20two%20figures%2C%20graphite%20linework%20on%20warm%20paper%2C%20soft%20shading%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-pencil-1&orientation=portrait",
  },
  {
    id: "c12",
    title: "玫瑰与夜莺",
    author: "韩舟",
    year: "2023",
    style: "复古手绘",
    type: "欧风",
    rating: 8.8,
    chapters: 35,
    status: "完结",
    tags: ["欧风", "贵族", "宿命"],
    desc: "暮色花园里玫瑰与夜莺的约定，复古油画般的质感，讲尽一段跨越身份的深情。",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20vintage%20illustration%2C%20european%20garden%20with%20roses%20at%20dusk%2C%20two%20figures%2C%20warm%20gold%20and%20deep%20red%2C%20classic%20painting%20style%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-retro-2&orientation=portrait",
  },
  {
    id: "c13",
    title: "星轨交叠",
    author: "陆离",
    year: "2024",
    style: "赛璐璐上色",
    type: "科幻",
    rating: 8.3,
    chapters: 30,
    status: "连载",
    tags: ["科幻", "星海", "伙伴"],
    desc: "星际航行的漫长旅程中，两条星轨逐渐交叠，明快的赛璐璐上色让太空也温暖起来。",
    cover:
      "https://readdy.ai/api/search-image?query=glossy%20anime%20cel%20style%2C%20starry%20night%20observatory%2C%20warm%20glowing%20stars%2C%20two%20figures%2C%20crisp%20saturated%20warm%20tones%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-cell-2&orientation=portrait",
  },
  {
    id: "c14",
    title: "月光序章",
    author: "闻歌",
    year: "2023",
    style: "水彩晕染",
    type: "现代",
    rating: 9.0,
    chapters: 33,
    status: "完结",
    tags: ["现代", "治愈", "久别"],
    desc: "月光洒满阳台的夜晚，一段未写完的故事重新起笔，水彩般柔软地照进心里。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20watercolor%20illustration%2C%20moonlit%20balcony%2C%20two%20figures%2C%20warm%20cream%20and%20gold%20moonlight%20washes%2C%20gentle%20flowing%20pigment%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-watercolor-2&orientation=portrait",
  },
  {
    id: "c15",
    title: "琴弦未眠",
    author: "祝千秋",
    year: "2024",
    style: "铅笔线稿",
    type: "音乐",
    rating: 8.6,
    chapters: 27,
    status: "连载",
    tags: ["音乐", "搭档", "和解"],
    desc: "琴房夜灯下，两位乐手在一次次合奏里学会聆听彼此，铅笔笔触安静又动人。",
    cover:
      "https://readdy.ai/api/search-image?query=pencil%20sketch%20illustration%2C%20grand%20piano%20room%2C%20warm%20lamplight%2C%20two%20figures%2C%20graphite%20and%20soft%20sepia%20tone%2C%20manga%20cover%2C%20no%20text&width=600&height=900&seq=cover-pencil-2&orientation=portrait",
  },
];